<div>
  <button mat-raised-button>Basic</button>
  <button mat-raised-button color="primary">Primary</button>
  <button mat-raised-button color="accent">Accent</button>
  <button mat-raised-button color="warn">Warn</button>
  <button mat-raised-button disabled>Disabled</button>
  <span class="me-2">bootstrap</span><span>test</span>
</div>
<button mat-raised-button (click)="testToastr()">トースターテスト</button>
<button mat-raised-button (click)="testWriteLog()">ログ出力テスト</button>
<div>
  <app-message-field></app-message-field>
</div>
<div>
  <app-upload-file></app-upload-file>
</div>
<div>
  <app-tableau-embed url="/views/20211015_AB_/sheet0" elementId="vizContainer" class="looker-embed"></app-tableau-embed>
</div>
